import appConfig from "../app.config";

var oauthSettings = {
  client_id: appConfig.settings.clientId,
  scope: appConfig.settings.scope,
  authorize_url: appConfig.settings.authorizeUrl,
  token_url: appConfig.settings.tokenUrl,
  logout_url: appConfig.settings.logoutUrl,
  redirect_uri: window.location.origin, //Gets the current
  autologin: true,
  debug: false,
};

/*----------------------------- Be careful below this line -------------------------------*/

import credentialsMixin from "@/_mixins/credentials-mixin";

export default {
  components: {},
  mixins: [credentialsMixin],
  data() {
    return oauthSettings;
  },
  computed: {
    credentials: {
      get() {
        if (this.credentialCacheUID > 0) {
          return this.getCredentials(this.client_id);
        }
        return null;
      },
      set(newVal) {
        if (!!newVal) {
          this.addCredentials(this.client_id, newVal);
        }
      },
    },
    isLoggedIn() {
      return !!this.credentials;
    }
  },
  methods: {
    // login() method removed - auth now handled by auth-service.js via main.js
  },
};
